import { useCallback, useState } from 'react'
import { toast } from 'sonner'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'
import { triggerBlobDownload } from '@/frontend/lib/download'

/**
 * Downloads every file attached to a patient as a single zip. The backend
 * streams the archive, so this is one authenticated request and one download —
 * far more reliable than triggering a separate browser download per file.
 * Exposes `isDownloading` for button loading state.
 */
export function useDownloadPatientFiles(patientId: string) {
  const api = useOsApi()
  const [isDownloading, setIsDownloading] = useState(false)

  const download = useCallback(async (): Promise<void> => {
    setIsDownloading(true)
    const result = await api.get('/patients/:patientId/files/download', { params: { patientId } })
    if (result.success) triggerBlobDownload(result.data, result.data.name)
    else toast.error('Failed to download files')
    setIsDownloading(false)
  }, [api, patientId])

  return { download, isDownloading }
}
